/**
 * 首页
 */
import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { HelperCore } from '@/common/helper';
import ChatInput from '@/components/chat/ChatInput';
import Footer from '@/components/footer';
import appLogger from '@public/log/monitor';
import globalStore from '@/store/global';
import Tooltip from "@/ui/tooltip"
import navbarStore from '@/store/navbar';
import modelChoiceStore from '@/components/model-choice/store.js';
import client from '@/store/client';
import { useState } from 'react';
import store from './store';
import EE from '@/common/event';

// 文件上传
import { usePageDropzone } from '@/components/page-dropzone';

import chatStoreManager from '@/store/chat/manager';
import Examples from '@/components/examples';

import DownloadBtn from './components/download-btn';
import agentPageStore from '../agent-home/store';
import useScroll from '@/hooks/useScroll';
import TopTab from '../agent-home/components/top-tab';

import ScrollView from '@/ui/scroll-view';
import FieldCategory from '@/components/field-category';
import SearchPage from '../search';
import InviteBtn from '@src/pages/agent-home/components/invite-btn';
import AgentLimit from '@/components/agent-limit';
import userStore from '@/store/user';
import { INVITE_STATUS_ACTIVE } from '@/components/modal/invite-form/constant';
import InviteUseBtn from '../agent-home/components/invite-use-btn';
import GenFileTypes from './components/gen-file-types';
import HomeSimpleAgents from './components/simple-agents';
import ShowBlance from '@/components/agent-limit/showBlance';
import homeStore from './store';
import SearchStation from './components/search-station';
import AgentRecommand from '@/components/agent-recommand';
import AgentCustomInput from './AgentCustomInput';
import AgentInput from '@/pages/agent-home/components/agent-input';
import CreateBtn from '@/pages/agent-home/components/create-btn';
import { useMeasure } from 'react-use';
import BackBtn from './components/back-btn';
import FoldBtn from '@/ui/fold-btn';

import "./index-scroll.scss"

const SearchHomePage = observer(() => {
  const [scroll, scrollElementRef] = useScroll();
  const [isShowAct, setShowAct] = useState(false)
  const { search_id } = useParams();
  const location = useLocation();
  const sugList = store.sugList;
  const isMac = HelperCore.isMac();
  const [headerRef, { width: widthHeaderContainer }] = useMeasure();
  const [smallTab, setSmallTab] = useState(false);

  //web页面和支持MCP的客户端里展示新首页样式，低版本客户端里展示老的首页样式
  const showExample = !client.isLLQ || client.supportMcpAgent;

  let assistantHomeBanner = globalStore.cloudConfig?.assistantHomeBanner || [];
  assistantHomeBanner = assistantHomeBanner[0] || {};

  useEffect(() => {
    if(location.pathname === '/'){
      EE.emit('chat_input_focus');
    }
    appLogger.log({
      key: 'aiso_home',
      action: 'show',
      arrt: 'aiso_home',
      page: 'aiso_home',
    });
  }, [location]);

  const handleClickOutside = event => {
    try {
      if (event.target.className.includes('ant-input')) {
        return;
      }
    } catch (error) {}
    if (store.curSugInfo.category) {
      store.setData('curSugInfo', {});
    }
  };

  useEffect(() => {
    agentPageStore.getAgents();
    chatStoreManager.setCurrentId(null);
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
      agentPageStore.switchTab(0);
      // 移除信息流展示打点的定时器
      clearTimeout(store.recoWordTimer);
      homeStore.setData('showSearching', false);
    };
  }, []);

  useEffect(() => {
    const startTime = new Date('2025-06-06 10:00:00').getTime();
    const endTime = new Date('2025-06-09 12:00:00').getTime();
    const currentTime = Date.now()
    if (currentTime >= startTime && currentTime < endTime) {
      setShowAct(true)
    } else {
      setShowAct(false)
    }
  }, [])

  // 通过判断是否存在 <UploadButton id=Tag_UploadButton /> 组件来决定是否激活拖放上传
  const [activeDropzone, setActiveDropzone] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      const isUploadBtn = document.getElementById('Tag_UploadButton');
      if (isUploadBtn) {
        return setActiveDropzone(true);
      }
      setActiveDropzone(false);
    }, 500);
  }, [location]);

  useEffect(() => {
    if (!userStore.isUser) return;
    globalStore.getInviteStaus();
  }, [userStore.isUser]);

  useEffect(() => {
    let maxWidth = 900
    if(agentPageStore.isFocus) {
      maxWidth += 300
    }
    if(!(client.isClient || client.isLLQ || client.isSeLLQ)) {
      maxWidth += 148
    }
    if(isShowAct && client.isLLQ) {
      maxWidth += 124
    }
    if(!userStore.isUser) {
      maxWidth -= 400
    }
    if(userStore.isCompanyUser) {
      maxWidth += 170
    }
    setSmallTab(widthHeaderContainer < maxWidth);
  }, [agentPageStore.isFocus, widthHeaderContainer])

  const { getRootProps, HideInput, DragArea, isDragActive } = usePageDropzone({
    currAsstId: modelChoiceStore.curId,
  });

  const logo = 'https://p4.ssl.qhimg.com/t110b9a9301b38c0ce79894a814.png';
  return (
    <div
      className="w-full h-full flex flex-col relative px-0px"
      id="ASSISTANT_SEARCH_HOME_WRAPPER"
      {...getRootProps(activeDropzone)}
      style={{
        backgroundImage: `url(https://p2.ssl.qhimg.com/t110b9a93013be09a129a3803c2.png)`,
        backgroundSize: '20px 20px',
      }}
    >
      <div
        style={{
          // paddingLeft: `calc((100% - 800px) / 2)`,
          height: '72px',
          background: `linear-gradient(
              to bottom,
              #fff,    /* 起始颜色和位置 */
              rgba(255,255,255,0)   /* 结束颜色和位置 */
          )`
        }}
      >
        <div
          className={[
            "flex items-center justify-end px-24px py-18px",
            navbarStore.isCollapse ? "pl-80px" : ""
          ]}
          ref={headerRef}
        >
          <BackBtn />
          {userStore.isUser && typeof agentPageStore?.chatLimit?.is_new === 'boolean' ? (agentPageStore?.chatLimit?.is_new ? <InviteUseBtn className="z-10 mr-0" /> : globalStore.inviteCodeStatus === INVITE_STATUS_ACTIVE ? <InviteBtn className="z-10 mr-10px" small={smallTab} /> : <InviteUseBtn className="z-10 mr-0" />) : null}
          {userStore.isUser ? <AgentLimit pos='aiso' className="mr-10px h-32px" /> : null}
          {userStore.isUser ? <ShowBlance className='mr-10px' /> : null}
          <div className='w-0px flex-grow'></div>
          {
            (isShowAct && client.isLLQ ) ?
            <Tooltip title="【有奖调研】纳米AI满意度调研，诚邀您的参与～">
              <div onClick={() => {
                client.openPage('https://www.wjx.cn/vm/w4ShPiL.aspx')
              }} className='w-124px cursor-pointer relative h-32px flex items-center rounded-16px z-10 mr-10px' style={{background: 'linear-gradient(90deg, #0AC0FD 0%, #019AEF 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.06) 0%,  rgba(0, 0, 0, 0.06) 100%), #FFF'}}>
                <img className='absolute w-54px h-38px left-0 bottom-0' src="https://p3.ssl.qhimg.com/t110b9a9301a91acd5eb4d1efbd.png" />
                <span className='text-[#fff] text-14px font-medium pl-56px'>有奖调研</span>
              </div>
            </Tooltip>
            : null
          }
          <AgentInput scene={'top'} />
          {/* 创建工作流智能体入口，对内部员工开放 */}
          {
            userStore.isCompanyUser && location.pathname == "/" && globalStore.cloudConfig.webConfig?.support_flow_in_home == 1
            ? (
              <FoldBtn
                text="创建工作流智能体"
                tips="创建工作流智能体"
                iconName="flow"
                className="!h-32px !mr-10px"
                small={smallTab}
                circle
                onClick={
                  () => {
                    client.openPage(`${import.meta.env.VITE_FLOW_HOST}?src=nami_home`);
                  }
                }
                />
            )
            : null
          }
          <CreateBtn small={smallTab} />
          <Tooltip title={smallTab ? "我的智能体" : ""}>
            <div
              className={[
                'h-32px rounded-full flex items-center box-border border-1px border-solid border-[rgba(0,0,0,0.16)] px-12px gap-6px ml-10px hover:bg-[rgba(0,0,0,0.03)] cursor-pointer mr-10px',
                smallTab ? "px-6px" : ""
              ]}
              onClick={() => {
                if(!userStore.isUser) {
                  userStore.gotoLogin();
                  return
                }
                globalStore.navigate("/tools/aiagent/mine")
              }}
            >
              <img
                src="https://p1.ssl.qhimg.com/t110b9a9301dc69af19a632795d.png"
                className='size-20px'
              />
              {
                !smallTab
                ? (
                  <div>我的智能体</div>
                )
                : null
              }
            </div>
          </Tooltip>
          <DownloadBtn small={smallTab} />
        </div>
      </div>
      {/* 搜索页面，则不展示AgentCustomInput */}
      {!search_id ? <AgentCustomInput /> : null}
      <ScrollView
        ref={scrollElementRef}
        destory={homeStore.showCustomInputPage}
        className="home-main-content-wrap outline-none h-0 flex-grow !pt-0px pb-0px search-home-scroll-wrap"
      >
        <div className='relative'>
          <div className='relative z-2'>
            <div
              id="input_content"
              className={[
                'w-full flex flex-col items-center relative px-40px',
                'transform transition duration-500 z-10 mt-106px',
              ]}
            >
              <div className="w-full flex items-center justify-center mb-12px relative">
                <img className="h-50px" src={logo} alt="" />
              </div>
              <div className="max-w-800px text-16px mb-32px leading-24px">
                自主规划复杂任务，分解步骤使用工具执行，交付专家级结果，每个人都可以成为超级个体
              </div>
              <div className="home-input-wrap w-full max-w-800px min-w-652px">
                <HomeSimpleAgents />
                <ChatInput
                  scene="aiso"
                  sugStore={store}
                  sug={{
                    ...store.curSugInfo,
                    ...(sugList[store.curSugInfo.category] || {}),
                  }}
                />
                <AgentRecommand />
                {/* <GenFileTypes /> */}
              </div>
            </div>

            {
              showExample
              ? <div className='mt-[60px]'>
                  <Examples scene='home' />
                </div>
              : null
            }
          </div>
          <div
            className='absolute w-full h-full z-1 left-0 top-0 flex flex-col pointer-events-none'
          >
            <div
              style={{
                height: "calc(100vh - 500px)"
              }}
            ></div>
            <div
              className='bg-black h-0 flex-grow w-full'
              style={{
                background: `linear-gradient(
                  to bottom,
                  rgba(255,255,255,0) 0,
                  rgba(255,255,255,1) 500px
                )`,
              }}
            ></div>
          </div>
        </div>
      </ScrollView>
      <Footer className="pointer-events-none w-full h-80px mx-auto bg-primary-2" />
      <div
        className={[
          'absolute inset-0 size-full z-500',
          search_id ? '' : 'hidden',
        ]}
      >
        <SearchPage id={search_id} />
      </div>
      {homeStore.showSearching ? <SearchStation text={homeStore.showSearching} /> : null}
    </div>
  );
});

export default SearchHomePage;
